import * as React from "react";
import type { SVGProps } from "react";
const SvgFileEdit01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.557 21.557h-4.8a2.4 2.4 0 0 1-2.4-2.4v-14.4a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v4.8m-4.8 8.692 5.092-5.092 3.394 3.394-5.091 5.092h-3.394z"
    />
  </svg>
);
export default SvgFileEdit01;
